"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBlob = exports.toBase64String = exports.toBuffer = exports.compile = void 0;
const KojiDocxDocumentConverter_1 = require("./KojiDocxDocumentConverter");
const JSZip = require("jszip");
function compile(ast) {
    const converter = new KojiDocxDocumentConverter_1.KojiDocxDocumentConverter();
    const doc = converter.convert(ast);
    const rels = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument"
                  Target="word/document.xml"/>
</Relationships>`;
    const relationships = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">

</Relationships>`;
    const contentType = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
    <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
    <Default Extension="xml" ContentType="application/xml"/>
    <Override PartName="/word/document.xml"
              ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/>
</Types>`;
    const zip = new JSZip();
    zip.file("_rels/.rels", rels);
    zip.file("word/_rels/document.xml.rels", relationships);
    zip.file("word/document.xml", doc);
    zip.file("[Content_Types].xml", contentType);
    return zip;
}
exports.compile = compile;
function toBuffer(ast) {
    return __awaiter(this, void 0, void 0, function* () {
        const zip = compile(ast);
        const zipData = yield zip.generateAsync({
            type: "nodebuffer",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            compression: "DEFLATE",
        });
        return zipData;
    });
}
exports.toBuffer = toBuffer;
function toBase64String(ast) {
    return __awaiter(this, void 0, void 0, function* () {
        const zip = compile(ast);
        const zipData = yield zip.generateAsync({
            type: "base64",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            compression: "DEFLATE",
        });
        return zipData;
    });
}
exports.toBase64String = toBase64String;
function toBlob(ast) {
    return __awaiter(this, void 0, void 0, function* () {
        const zip = compile(ast);
        const zipData = yield zip.generateAsync({
            type: "blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            compression: "DEFLATE",
        });
        return zipData;
    });
}
exports.toBlob = toBlob;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS29qaURvY3hDb21waWxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb252ZXJ0ZXIvS29qaURvY3hDb21waWxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSwyRUFBd0U7QUFFeEUsK0JBQStCO0FBRS9CLFNBQWdCLE9BQU8sQ0FBQyxHQUFxQjtJQUN6QyxNQUFNLFNBQVMsR0FBRyxJQUFJLHFEQUF5QixFQUFFLENBQUM7SUFDbEQsTUFBTSxHQUFHLEdBQUcsU0FBUyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUNuQyxNQUFNLElBQUksR0FBRzs7OztpQkFJQSxDQUFDO0lBQ2QsTUFBTSxhQUFhLEdBQUc7OztpQkFHVCxDQUFDO0lBQ2QsTUFBTSxXQUFXLEdBQUc7Ozs7OztTQU1mLENBQUM7SUFDTixNQUFNLEdBQUcsR0FBRyxJQUFJLEtBQUssRUFBRSxDQUFDO0lBQ3hCLEdBQUcsQ0FBQyxJQUFJLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQzlCLEdBQUcsQ0FBQyxJQUFJLENBQUMsOEJBQThCLEVBQUUsYUFBYSxDQUFDLENBQUM7SUFDeEQsR0FBRyxDQUFDLElBQUksQ0FBQyxtQkFBbUIsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUNuQyxHQUFHLENBQUMsSUFBSSxDQUFDLHFCQUFxQixFQUFFLFdBQVcsQ0FBQyxDQUFDO0lBQzdDLE9BQU8sR0FBRyxDQUFDO0FBQ2YsQ0FBQztBQXpCRCwwQkF5QkM7QUFFRCxTQUFzQixRQUFRLENBQUMsR0FBcUI7O1FBQ2hELE1BQU0sR0FBRyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUN6QixNQUFNLE9BQU8sR0FBRyxNQUFNLEdBQUcsQ0FBQyxhQUFhLENBQUM7WUFDcEMsSUFBSSxFQUFFLFlBQVk7WUFDbEIsUUFBUSxFQUFFLHlFQUF5RTtZQUNuRixXQUFXLEVBQUUsU0FBUztTQUN6QixDQUFDLENBQUM7UUFDSCxPQUFPLE9BQU8sQ0FBQztJQUNuQixDQUFDO0NBQUE7QUFSRCw0QkFRQztBQUVELFNBQXNCLGNBQWMsQ0FBQyxHQUFxQjs7UUFDdEQsTUFBTSxHQUFHLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3pCLE1BQU0sT0FBTyxHQUFHLE1BQU0sR0FBRyxDQUFDLGFBQWEsQ0FBQztZQUNwQyxJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRSx5RUFBeUU7WUFDbkYsV0FBVyxFQUFFLFNBQVM7U0FDekIsQ0FBQyxDQUFDO1FBQ0gsT0FBTyxPQUFPLENBQUM7SUFDbkIsQ0FBQztDQUFBO0FBUkQsd0NBUUM7QUFFRCxTQUFzQixNQUFNLENBQUMsR0FBcUI7O1FBQzlDLE1BQU0sR0FBRyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUN6QixNQUFNLE9BQU8sR0FBRyxNQUFNLEdBQUcsQ0FBQyxhQUFhLENBQUM7WUFDcEMsSUFBSSxFQUFFLE1BQU07WUFDWixRQUFRLEVBQUUseUVBQXlFO1lBQ25GLFdBQVcsRUFBRSxTQUFTO1NBQ3pCLENBQUMsQ0FBQztRQUNILE9BQU8sT0FBTyxDQUFDO0lBQ25CLENBQUM7Q0FBQTtBQVJELHdCQVFDIn0=